import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axiosInstance from "../../utils/axios";

type ModuleState = {
  isLoading: boolean;
  error: boolean;
  modules: { id: number; module_name: string }[];
};

const initialState: ModuleState = {
  isLoading: false,
  error: false,
  modules: []
};

const slice = createSlice({
  name: "module",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // COMPANY LISTING
    getModuleListSuccess(state, action) {
      state.isLoading = false;
      state.modules = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function getModules() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.get(`/modules`);
      dispatch(slice.actions.getModuleListSuccess(response?.data || []));
      if (response?.error) {
        throw new Error(response?.error);
      }
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function startLoading() {
  return async () => dispatch(startLoading);
}

export function stopLoading() {
  return async () => dispatch(stopLoading);
}
